
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAppleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.95 4.047a3.001 3.001 0 0 1 2.8-1.922",
  stroke: "#000",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M20.485 16.275c-.616 1.506-1.496 2.798-2.45 3.687-.872.811-1.806 1.288-2.66 1.288h-6.75c-2.625 0-6-4.5-6-9.375A5.625 5.625 0 0 1 12 7.683h0a5.626 5.626 0 0 1 8.172.715h0a4.501 4.501 0 0 0 .313 7.877h0Z",
  stroke: "#000",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\r\n<path d=\"M12.9492 4.04744C13.3954 2.8891 14.5086 2.12496 15.7499 2.125\" stroke=\"black\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.4855 16.2751C19.8689 17.7813 18.9893 19.0729 18.0342 19.9623C17.1631 20.7734 16.2293 21.2501 15.375 21.2501H8.625C6 21.2501 2.625 16.7501 2.625 11.8751C2.62502 9.65684 3.92872 7.64574 5.95371 6.74017C7.97871 5.8346 10.3468 6.20369 12.0002 7.68256L12 7.68238C13.1582 6.64661 14.6932 6.13597 16.241 6.27156C17.7888 6.40715 19.2116 7.17688 20.1721 8.39825L20.1721 8.39826C18.7691 9.24669 17.9384 10.7908 18.0036 12.429C18.0687 14.0672 19.0193 15.5405 20.4851 16.2749L20.4855 16.2751Z\" stroke=\"black\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/apple-icon.cb8ac2e6c5d95a6d6fdf8ab3e81e1399.svg"),
        {
          React: SvgAppleIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      